export default {
	NAV_HEADER: 'Your Workplaces'
};